import { render, staticRenderFns } from "./SectionProductHero.vue?vue&type=template&id=607d7ad9&scoped=true&"
import script from "./SectionProductHero.vue?vue&type=script&lang=ts&"
export * from "./SectionProductHero.vue?vue&type=script&lang=ts&"
import style0 from "./SectionProductHero.vue?vue&type=style&index=0&id=607d7ad9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d7ad9",
  null
  
)

export default component.exports